import React, { PropsWithChildren, useMemo, useState } from 'react';

import { UniverseReference } from '@front/common/src/types/commons';

import { SignupResponse } from '@front/pro/src/types/pro';
import {
  WorkingInformationFR,
  WorkingInformationUK,
  RevenueSimulatorInformation,
  UserInformation,
  AdditionalInformation,
} from '@front/pro/src/signup/types';
import { SignupFormContext } from '@front/pro/src/signup/signup-form-context';

import useLocalStorage from '../hooks/use-local-storage';

export const SignupFormContextProviderWeb = ({ children }: PropsWithChildren<{}>) => {
  const [revenueSimulator, setRevenueSimulator] = useLocalStorage<RevenueSimulatorInformation>('revenueSimulator');
  const [userInformation, setUserInformation] = useLocalStorage<UserInformation>('userInformation');
  const [workingInformation, setWorkingInformation] = useLocalStorage<WorkingInformationFR | WorkingInformationUK>(
    'workingInformation',
  );
  const [additionalInformation, setAdditionalInformation] =
    useLocalStorage<AdditionalInformation>('additionalInformation');
  const [subscribedPro, setSubscribedPro] = useLocalStorage<SignupResponse | undefined>('subscribedPro');
  // Need to cast as the universe we get from window is of type string
  const [universe, setUniverse] = useState<UniverseReference>(window.wecasa.universe as UniverseReference);

  const value = useMemo(
    () => ({
      revenueSimulator,
      userInformation,
      workingInformation,
      additionalInformation,
      subscribedPro,
      universe,
      setUserInformation,
      setWorkingInformation,
      setAdditionalInformation,
      setRevenueSimulator,
      setSubscribedPro,
      setUniverse,
    }),
    [
      revenueSimulator,
      userInformation,
      workingInformation,
      additionalInformation,
      subscribedPro,
      universe,
      setUserInformation,
      setWorkingInformation,
      setAdditionalInformation,
      setRevenueSimulator,
      setSubscribedPro,
      setUniverse,
    ],
  );

  return <SignupFormContext.Provider value={value}>{children}</SignupFormContext.Provider>;
};
